import { render, staticRenderFns } from "./GalleryCustom.vue?vue&type=template&id=0c904cba&"
import script from "./GalleryCustom.vue?vue&type=script&lang=js&"
export * from "./GalleryCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports